import React, { useState } from "react";
import ReleasePreview from "./ReleasePreview";
import { useParams } from "react-router-dom";
import { RequestState } from "../../../utils/RequestState";
import { CategoryState } from "../../../utils/CategoryState";
import { useAppSelector } from "../../../redux/hooks";
import { getAuthToken } from "../../../redux/reducers/auth";
import FacilityDetail from "../../../features/facility/FacilityDetail";
import {
  useApproveFacility,
  useGetFacilityAdmin,
} from "../../../utils/useFacility";

const ReleaseFacilityPreviewContainer: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  const [activeModal, setActiveModal] = useState<CategoryState>(
    CategoryState.None
  );
  const [requestState, setRequestState] = useState<RequestState>(
    RequestState.Pending
  );
  const [message, setMessage] = useState<string>("");

  const auth_token = useAppSelector(getAuthToken);

  const queryArgs = { authToken: auth_token, id: id };

  const {
    items: { facilities },
    isLoading,
  } = useGetFacilityAdmin(queryArgs);
  const { mutateAsync, mutateLoading } = useApproveFacility([
    "facilityAdmin",
    queryArgs,
  ]);

  const handleInputChange = (value: string) => {
    setMessage(value);
  };

  const showModal = (modal: CategoryState) => {
    setActiveModal(modal);
  };

  const closeModal = () => {
    setActiveModal(CategoryState.None);
    setRequestState(RequestState.Pending);
  };

  const handleSubmit = async (approve: boolean) => {
    if (auth_token && id) {
      setRequestState(RequestState.Doing);

      await mutateAsync({
        auth_token: auth_token,
        id: id,
        message: message,
        approve: approve,
      });

      setRequestState(RequestState.Success);
    }
  };

  return (
    <ReleasePreview
      message={message}
      targetName={`${facilities[0]?.name}`}
      modalLink={`/facility/${id}`}
      activeModal={activeModal}
      requestState={requestState}
      closeModal={closeModal}
      showModal={showModal}
      handleSubmit={handleSubmit}
      handleInputChange={handleInputChange}
      isLoading={isLoading || mutateLoading}
      releaseType={`施設名`}
      editLink={{
        text: "SELeCTレビュー入力はこちら",
        link: `/admin/facility/${id}`,
      }}
    >
      <FacilityDetail {...facilities[0]} />
    </ReleasePreview>
  );
};

export default ReleaseFacilityPreviewContainer;
